import { css, StyleDeclaration, StyleSheet } from 'aphrodite';
import AnimatedSparkleUrl from '../../../assets/aiSparkleAnimated.gif';
import { SparkleIcon } from '../../svgs/icons/SparkleIcon';

const styles = StyleSheet.create({
	animated: {
		display: 'block',
		mixBlendMode: 'multiply',
		'@media (prefers-reduced-motion: reduce)': {
			display: 'none',
		},
	},
	static: {
		display: 'none',
		'@media (prefers-reduced-motion: reduce)': {
			display: 'block',
		},
	},
});

export function AnimatedSparkleIcon({ styles: styleOverrides = [] }: { styles?: StyleDeclaration[] }) {
	return (
		<>
			<img
				src={AnimatedSparkleUrl}
				alt='AI thinking'
				width={32}
				height={32}
				className={css(styles.animated, ...styleOverrides)}
			/>
			<SparkleIcon styles={[styles.static, ...styleOverrides]} />
		</>
	);
}
